import { actionConstants } from 'redux-layer/constants';
import {
  startReqActionType,
  successReqActionType,
  failReqActionType,
  authHeader,
  processResponse
} from 'helper/requestHelper';
import { getEnvironment } from 'helper/utils';

export const getGKEClusterMetrics = () => async dispatch => {
  dispatch({
    type: startReqActionType(actionConstants.GET_GKE_CLUSTER_METRICS)
  });
  try {
    const requestOptions = {
      method: 'GET',
      headers: authHeader()
    };

    const data = await fetch(
      `${getEnvironment().API_URL}admin/gke/cluster/metrics`,
      requestOptions
    );
    const retData = await processResponse(data);
    dispatch({
      type: successReqActionType(actionConstants.GET_GKE_CLUSTER_METRICS),
      payload: retData
    });
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.GET_GKE_CLUSTER_METRICS)
    });
  }
};

export const getGKEDeploymentsMetrics = () => async dispatch => {
  dispatch({
    type: startReqActionType(actionConstants.GET_GKE_DEPLOYMENTS_METRICS)
  });
  try {
    const requestOptions = {
      method: 'GET',
      headers: authHeader()
    };

    const data = await fetch(
      `${getEnvironment().API_URL}admin/gke/deployments/metrics`,
      requestOptions
    );
    const retData = await processResponse(data);
    dispatch({
      type: successReqActionType(actionConstants.GET_GKE_DEPLOYMENTS_METRICS),
      payload: retData
    });
  } catch (error) {
    dispatch({
      type: failReqActionType(actionConstants.GET_GKE_DEPLOYMENTS_METRICS)
    });
  }
};

export const getGKEDeploymentMetrics =
  (deploymentName, namespace = 'default') =>
  async dispatch => {
    dispatch({
      type: startReqActionType(actionConstants.GET_GKE_DEPLOYMENT_METRICS)
    });
    try {
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };

      const data = await fetch(
        `${
          getEnvironment().API_URL
        }admin/gke/deployment/${deploymentName}/metrics?namespace=${namespace}`,
        requestOptions
      );
      const retData = await processResponse(data);
      dispatch({
        type: successReqActionType(actionConstants.GET_GKE_DEPLOYMENT_METRICS),
        payload: retData
      });
    } catch (error) {
      dispatch({
        type: failReqActionType(actionConstants.GET_GKE_DEPLOYMENT_METRICS)
      });
    }
  };

export const getGKEPodsMetrics =
  (deploymentName, namespace = 'default') =>
  async dispatch => {
    dispatch({
      type: startReqActionType(actionConstants.GET_GKE_PODS_METRICS)
    });
    try {
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };

      const data = await fetch(
        `${
          getEnvironment().API_URL
        }admin/gke/deployment/${deploymentName}/pods/metrics?namespace=${namespace}`,
        requestOptions
      );
      const retData = await processResponse(data);
      dispatch({
        type: successReqActionType(actionConstants.GET_GKE_PODS_METRICS),
        payload: retData
      });
    } catch (error) {
      dispatch({
        type: failReqActionType(actionConstants.GET_GKE_PODS_METRICS)
      });
    }
  };

export const getGKEWorkloads =
  (namespace = null) =>
  async dispatch => {
    dispatch({ type: startReqActionType(actionConstants.GET_GKE_WORKLOADS) });
    try {
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };

      const url = namespace
        ? `${
            getEnvironment().API_URL
          }admin/gke/workloads?namespace=${namespace}`
        : `${getEnvironment().API_URL}admin/gke/workloads`;

      const data = await fetch(url, requestOptions);
      const retData = await processResponse(data);
      dispatch({
        type: successReqActionType(actionConstants.GET_GKE_WORKLOADS),
        payload: retData
      });
    } catch (error) {
      dispatch({ type: failReqActionType(actionConstants.GET_GKE_WORKLOADS) });
    }
  };

export const getGKEWorkloadPods =
  (workloadType, workloadName, namespace = 'default') =>
  async dispatch => {
    dispatch({
      type: startReqActionType(actionConstants.GET_GKE_WORKLOAD_PODS)
    });
    try {
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };

      const data = await fetch(
        `${
          getEnvironment().API_URL
        }admin/gke/workload/${workloadType}/${workloadName}/pods?namespace=${namespace}`,
        requestOptions
      );
      const retData = await processResponse(data);
      dispatch({
        type: successReqActionType(actionConstants.GET_GKE_WORKLOAD_PODS),
        payload: retData
      });
    } catch (error) {
      dispatch({
        type: failReqActionType(actionConstants.GET_GKE_WORKLOAD_PODS)
      });
    }
  };

export const getGKEPodLogs =
  (podName, namespace = 'default', container = null, tailLines = 100) =>
  async dispatch => {
    dispatch({ type: startReqActionType(actionConstants.GET_GKE_POD_LOGS) });
    try {
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };

      let url = `${
        getEnvironment().API_URL
      }admin/gke/pod/${podName}/logs?namespace=${namespace}&tail_lines=${tailLines}`;
      if (container) {
        url += `&container=${container}`;
      }

      const data = await fetch(url, requestOptions);
      const retData = await processResponse(data);
      dispatch({
        type: successReqActionType(actionConstants.GET_GKE_POD_LOGS),
        payload: retData
      });
      return retData;
    } catch (error) {
      dispatch({ type: failReqActionType(actionConstants.GET_GKE_POD_LOGS) });
      throw error;
    }
  };

export const getGKEWorkloadLogs =
  (workloadType, workloadName, namespace = 'default', tailLines = 100) =>
  async dispatch => {
    dispatch({
      type: startReqActionType(actionConstants.GET_GKE_WORKLOAD_LOGS)
    });
    try {
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };

      const data = await fetch(
        `${
          getEnvironment().API_URL
        }admin/gke/workload/${workloadType}/${workloadName}/logs?namespace=${namespace}&tail_lines=${tailLines}`,
        requestOptions
      );
      const retData = await processResponse(data);
      dispatch({
        type: successReqActionType(actionConstants.GET_GKE_WORKLOAD_LOGS),
        payload: retData
      });
      return retData;
    } catch (error) {
      dispatch({
        type: failReqActionType(actionConstants.GET_GKE_WORKLOAD_LOGS)
      });
      throw error;
    }
  };
